module.exports = __webpack_public_path__ + "img/微信图片_20250612154310.16368d8d.png";